// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
export * from './Icon'
export * from './regularIcons'
export * from './solidIcons'